module.exports = __webpack_public_path__ + "assets/img/footer-wave.017c91ee.svg";